import { render, staticRenderFns } from "./union-card-recieved-popup.vue?vue&type=template&id=600dbeb0&scoped=true&lang=pug&"
import script from "./union-card-recieved-popup.vue?vue&type=script&lang=js&"
export * from "./union-card-recieved-popup.vue?vue&type=script&lang=js&"
import style0 from "./union-card-recieved-popup.vue?vue&type=style&index=0&id=600dbeb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600dbeb0",
  null
  
)

export default component.exports